import { render, staticRenderFns } from "./Woonbox.vue?vue&type=template&id=12d27fc8&"
import script from "./Woonbox.vue?vue&type=script&lang=js&"
export * from "./Woonbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports